import React, { useEffect, useState } from 'react';
import { LayoutBlockHeroProps } from 'src/modules/layout/components/block/hero/LayoutBlockHero';
import { LayoutBlockFullHeroProps } from 'src/modules/layout/components/block/fullHero/LayoutBlockFullHero';
import { LayoutBlockTextImageProps } from 'src/modules/layout/components/block/textImage/LayoutBlockTextImage';
// import { LayoutBlockMultiImageProps } from 'src/modules/layout/components/block/multiImage/LayoutBlockMultiImage';
import { LayoutBlockSideBySideImagesProps } from 'src/modules/layout/components/block/sideBySideImages/LayoutBlockSideBySideImages';
import LayoutCard, { LayoutCardProps } from 'src/modules/layout/components/card/LayoutCard';
import LayoutCardsDownloads from 'src/modules/layout/components/block/cardsDownloads/LayoutCardsDownloads';
import { QuoteProps } from 'src/modules/global/components/quote/Quote';
import { VideoProps } from 'src/modules/global/components/video/Video';
import { GalleryProps } from 'src/modules/global/components/gallery/Gallery';
import { ProductContextProps } from 'src/modules/global/components/productContext/ProductContext';
import { CtaProps } from 'src/modules/global/components/cta/Cta';
import { ImageEntity } from 'src/modules/global';
import { Locale, useLocale, filterModelsByOutputChannel } from 'src/modules/locale';
import styles from './LayoutDynamicZone.module.scss';
import classnames from 'classnames';
import { Media } from 'react-breakpoints';

import {
  LayoutBlockHero,
  LayoutBlockFullHero,
  LayoutBlockTextImage,
  LayoutBlockMultiImage,
  LayoutBlockText,
  LayoutBlockSideBySideImages,
  LayoutCardSize,
  LayoutCardType,
  LayoutCardList,
} from 'src/modules/layout';
import {
  GlobalQuote,
  GlobalVideo,
  GlobalImage,
  ImageType,
  GlobalGallery,
  GlobalProductContext,
  GlobalCta,
} from 'src/modules/global';
import { breakpoints } from 'src/utils/breakpoints';

//Rest API will return different strings for the components
export enum LayoutDynamicZoneComponentTypes {
  FullHero = 'ComponentTextImageFullWidthHero',
  RestFullHero = 'ComponentTextImageFullWidthHero',
  Hero = 'ComponentTextImageHero',
  RestHero = 'ComponentTextImageHero',
  TextImage = 'ComponentTextImageTextAndImage',
  RestTextImage = 'text-image.text-and-image',
  Quote = 'ComponentTextQuote',
  RestQuote = 'text.quote',
  TextBlock = 'ComponentTextTextBlock',
  RestTextBlock = 'text.text-block',
  Media = 'ComponentMediaMedia',
  RestMedia = 'ComponentMediaMedia',
  Video = 'ComponentMediaVideo',
  RestVideo = 'media.video',
  SideBySideImages = 'ComponentMediaSideBySideImages',
  RestSideBySideImages = 'media.side-by-side-images',
  Card = 'ComponentTextImageCard',
  CardsDownloadsLayout = 'ComponentTextImageCardsDownloadsLayout',
  RestCard = 'text-image.card',
  MultiImageLayout = 'ComponentTextImageMultiImageLayout',
  RestMultiImageLayout = 'text-image.multi-image-layout',
  Image = 'ComponentMediaImage',
  RestImage = 'media.image',
  Gallery = 'ComponentMediaGallery',
  RestGallery = 'media.gallery',
  ProductContext = 'ComponentMediaProductInContext',
  RestProductContext = 'media.product-in-context',
  CtaButton = 'ComponentCtaButton',
  RestCtaButton = 'cta.button',
  TemplateS = 'ComponentTemplateS',
  TemplateM = 'ComponentTemplateM',
  TemplateL = 'ComponentTemplateL',
  CardGroup = 'CardGroup',
}

interface CardComponentProps extends LayoutCardProps {
  id: string;
  image: ImageEntity;
  slug: string;
  title: string;
}

export interface LayoutDynamicZoneComponentProps
  extends LayoutBlockHeroProps,
    LayoutBlockFullHeroProps,
    LayoutBlockTextImageProps,
    // LayoutBlockTextProps,
    LayoutBlockSideBySideImagesProps,
    QuoteProps,
    VideoProps,
    // ImageProps,
    // LayoutBlockMultiImageProps,
    CardComponentProps,
    GalleryProps,
    ProductContextProps,
    CtaProps {
  __typename: LayoutDynamicZoneComponentTypes;
  __component: LayoutDynamicZoneComponentTypes;
  locale: Locale;
  gallery?: any;
  text_top?: any;
  side_images?: any;
  text_bottom?: any;
  text: any;
  text_image?: any;
  quote: any;
  products: any;
  type: any;
  button: any;
}

interface LayoutDynamicZoneProps {
  components: LayoutDynamicZoneComponentProps[];
  link?: string;
  size?: LayoutCardSize;
  type?: LayoutCardType;
  filter?: LayoutDynamicZoneComponentTypes;
  exclude?: LayoutDynamicZoneComponentTypes;
  className?: string;
  groupCards?: boolean;
}

const LayoutDynamicZone: React.FunctionComponent<LayoutDynamicZoneProps> = (
  props: LayoutDynamicZoneProps
) => {
  const [hack, setHack] = useState('');

  useEffect(() => {
    setHack('hack');
  }, []);

  const {
    Hero,
    RestHero,
    FullHero,
    RestFullHero,
    TextImage,
    RestTextImage,
    MultiImageLayout,
    RestMultiImageLayout,
    Quote,
    RestQuote,
    Video,
    RestVideo,
    TextBlock,
    RestTextBlock,
    SideBySideImages,
    RestSideBySideImages,
    Card,
    CardsDownloadsLayout,
    RestCard,
    CardGroup,
    Image,
    RestImage,
    Gallery,
    RestGallery,
    ProductContext,
    RestProductContext,
    CtaButton,
    RestCtaButton,
  } = LayoutDynamicZoneComponentTypes;

  const { locale, outputChannel } = useLocale();

  const { components, filter, link, exclude, ...restDynamicZoneProps } = props;

  const componentsByChannel = filterModelsByOutputChannel(components, outputChannel);

  let processedComponents = [];

  // filter components
  const filteredComponents = componentsByChannel.filter(
    ({ __typename, locale: componentLocale }) =>
      (!filter || filter === __typename) &&
      (!exclude || exclude !== __typename) &&
      (!componentLocale || componentLocale.startsWith(locale))
  );

  // group the cards if needed
  if (props.groupCards) {
    let cardGroup = [];
    const addCardGroupToComponents = () => {
      if (cardGroup && cardGroup.length) {
        processedComponents.push({ __typename: CardGroup, cards: cardGroup });
        cardGroup = [];
      }
    };

    filteredComponents.forEach((c) => {
      if (c.__typename === Card || c.__component === RestCard) {
        cardGroup.push(c);
      } else {
        addCardGroupToComponents();
        processedComponents.push(c);
      }
    });
  } else {
    processedComponents = filteredComponents;
  }

  // generate the dynamic zone component output
  const output = processedComponents.map((component, idx) => {
    const { __typename, __component, locale: componentLocale, ...componentProps } = component;

    const componentType = __typename || __component;
    switch (componentType) {
      case Hero:
      case RestHero:
        return <LayoutBlockHero key={`LayoutBlockHero-${idx}`} {...componentProps} />;
      case FullHero:
      case RestFullHero:
        return <LayoutBlockFullHero key={`LayoutBlockFullHero-${idx}`} {...componentProps} />;
      case TextImage:
      case RestTextImage:
        return <LayoutBlockTextImage key={`LayoutBlockTextImage-${idx}`} {...componentProps} />;
      case MultiImageLayout:
      case RestMultiImageLayout:
        return <LayoutBlockMultiImage key={`LayoutBlockMultiImage-${idx}`} {...componentProps} />;
      case Quote:
      case RestQuote:
        return <GlobalQuote key={`GlobalQuote-${idx}`} {...componentProps} />;
      case Image:
      case RestImage:
        const { caption, image, products } = componentProps;
        return (
          <div key={`GlobalImage-${idx}`} className={`${styles.image} layout-dynamic-zone-image`}>
            <GlobalImage
              type={ImageType.FullRow}
              url={!!image && image.url}
              caption={caption}
              products={products}
              locale={componentLocale}
              captionSize="small"
            />
          </div>
        );
      case Video:
      case RestVideo:
        return <GlobalVideo key={`GlobalVideo-${idx}`} {...componentProps} />;
      case TextBlock:
      case RestTextBlock:
        return <LayoutBlockText key={`LayoutBlockText-${idx}`} {...componentProps} />;
      case SideBySideImages:
      case RestSideBySideImages:
        return (
          <LayoutBlockSideBySideImages
            key={`LayoutBlockSideBySideImages-${idx}`}
            {...componentProps}
          />
        );
      case Gallery:
      case RestGallery:
        return <GlobalGallery key={`GlobalGallery-${idx}`} {...componentProps} />;
      case ProductContext:
      case RestProductContext:
        return <GlobalProductContext key={`GlobalProductContext-${idx}`} {...componentProps} />;
      case CtaButton:
      case RestCtaButton:
        return <GlobalCta key={`GlobalCta-${idx}`} {...componentProps} align={true} />;
      case CardGroup:
        return (
          <Media key={`LayoutCardGroup-${idx}`}>
            {({ currentBreakpoint } = { currentBreakpoint: 'xs' }) => (
              <LayoutCardList
                size={
                  breakpoints[currentBreakpoint] < breakpoints.sm
                    ? LayoutCardSize.Big
                    : LayoutCardSize.Small
                }
                wrap={true}
                type={LayoutCardType.Overview}
                truncateTitle={false}
                dynamicRoute={false}
                {...restDynamicZoneProps}
                items={component.cards.map((card) => ({
                  id: card.id,
                  image: card.image,
                  slug: card.link,
                  link: link,
                  title: card.title,
                  description: card.body_text,
                }))}
              />
            )}
          </Media>
        );
      case Card:
      case RestCard:
        const data = {
          id: component.id,
          image: component.image,
          slug: component.link,
          link: link,
          title: component.title,
          description: component.body_text,
        };
        return (
          <LayoutCard
            key={`LayoutCard-${idx}`}
            data={data}
            type={LayoutCardType.Overview}
            dynamicRoute={false}
            {...restDynamicZoneProps}
          />
        );
      case CardsDownloadsLayout:
        return <LayoutCardsDownloads data={component} />;

      default:
        //Check if it's a template
        const {
          image: templateImage,
          text,
          gallery,
          text_top,
          side_images,
          text_bottom,
          quote,
          text_image,
        } = component;
        const templateComponents = [];
        if (templateImage) {
          templateComponents.push(
            <div key={`GlobalImage-${idx}`} className={styles.image}>
              <GlobalImage
                type={ImageType.FullRow}
                url={!!templateImage.image && templateImage.image?.url}
                caption={templateImage.caption}
                products={templateImage.products}
                locale={componentLocale}
                captionSize="small"
              />
            </div>
          );
        }
        if (text) {
          templateComponents.push(
            <LayoutBlockText key={`LayoutBlockText-${idx}`} body_text={text.body_text} />
          );
        }
        if (text_top) {
          templateComponents.push(
            <LayoutBlockText key={`LayoutBlockTextTop-${idx}`} {...text_top} />
          );
        }
        if (side_images) {
          templateComponents.push(
            <LayoutBlockSideBySideImages
              key={`LayoutBlockSideBySideImages-${idx}`}
              {...side_images}
            />
          );
        }
        if (quote) {
          templateComponents.push(<GlobalQuote key={`GlobalQuote-${idx}`} {...quote} />);
        }
        if (text_image) {
          templateComponents.push(
            <LayoutBlockTextImage key={`LayoutBlockTextImage-${idx}`} {...text_image} />
          );
        }
        if (text_bottom) {
          templateComponents.push(
            <LayoutBlockText key={`LayoutBlockTextBottom-${idx}`} {...text_bottom} />
          );
        }
        if (gallery) {
          templateComponents.push(<GlobalGallery key={`GlobalGallery-${idx}`} {...gallery} />);
        }
        if (templateComponents.length) {
          return <div key={`Template-${idx}`}>{templateComponents}</div>;
        }

        return null;
    }
  });
  return filter ? (
    <React.Fragment key={`LayoutDynamicZone-${hack}`}>{output}</React.Fragment>
  ) : (
    <div
      key={`LayoutDynamicZone-${hack}`}
      className={classnames(styles.container, props.className)}>
      {output}
    </div>
  );
};

export default LayoutDynamicZone;
